export default __webpack_public_path__ + "static/media/Lily.b1f05b56.webp";